__turbopack_context__.v({
  "animating": "ErpNextJourney-module__0IKTNq__animating",
  "badge": "ErpNextJourney-module__0IKTNq__badge",
  "eyebrow": "ErpNextJourney-module__0IKTNq__eyebrow",
  "head": "ErpNextJourney-module__0IKTNq__head",
  "iconWrap": "ErpNextJourney-module__0IKTNq__iconWrap",
  "rowTop": "ErpNextJourney-module__0IKTNq__rowTop",
  "scroller": "ErpNextJourney-module__0IKTNq__scroller",
  "section": "ErpNextJourney-module__0IKTNq__section",
  "step": "ErpNextJourney-module__0IKTNq__step",
  "stepDesc": "ErpNextJourney-module__0IKTNq__stepDesc",
  "stepDetail": "ErpNextJourney-module__0IKTNq__stepDetail",
  "stepTitle": "ErpNextJourney-module__0IKTNq__stepTitle",
  "subtitle": "ErpNextJourney-module__0IKTNq__subtitle",
  "title": "ErpNextJourney-module__0IKTNq__title",
  "track": "ErpNextJourney-module__0IKTNq__track",
  "visible": "ErpNextJourney-module__0IKTNq__visible",
});
